'use client'

import { HTMLAttributes, ReactElement, createElement } from 'react'
import DOMPurify from 'dompurify'
import { useIsClient } from '../../../hooks'

export interface RichTextProps extends HTMLAttributes<HTMLDivElement> {
    rawHtml: string
    tag?: keyof HTMLElementTagNameMap
}

export const RichText = ({ rawHtml, tag = 'div', ...rest }: RichTextProps): ReactElement => {
    const isClient = useIsClient()
    const html = isClient ? DOMPurify.sanitize(rawHtml, { RETURN_TRUSTED_TYPE: true }) : ''

    return createElement(tag, {
        className: `rich-text ${rest.className || ''}`,
        dangerouslySetInnerHTML: { __html: html },
    })
}
